/**
 * Labstep
 *
 * @desc Action to create PermissionRole
 */

import { CanCreate } from 'labstep-web/components/Entity/Can';
import { PermissionRoleFormCreate } from 'labstep-web/components/PermissionRole/Form/Create';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { PremiumFeatureScreenGuard } from 'labstep-web/core/PremiumFeature/ScreenGuard';
import type React from 'react';
import type { IPermissionRoleActionCreateProps } from './types';

export const PermissionRoleActionCreate: React.FC<
  IPermissionRoleActionCreateProps
> = ({ organization }) => (
  <CanCreate
    parentName={organization.entityName}
    parentId={organization.id}
    entityName="permission_role"
  >
    <ModalDefault
      header="Add Role"
      content={({ toggleModal }) => (
        <PremiumFeatureScreenGuard
          premiumFeature="custom_permissions"
          unstyled
        >
          <PermissionRoleFormCreate
            organization={organization}
            options={{ onSuccess: toggleModal }}
            onCancel={toggleModal}
          />
        </PremiumFeatureScreenGuard>
      )}
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          showIcon
          type="button"
          text="Add Role"
          elementProps={{
            primary: true,
            basic: true,
          }}
          icon="user plus"
          onClick={toggleModal}
        />
      )}
    />
  </CanCreate>
);
